// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"167":"detail","177":"home"}[chunkId] || chunkId) + "." + {"97":"aa87bd60","167":"658075f4","177":"4236cadb","389":"c20a9b1b","457":"ef11884d","581":"a0176455","659":"4d215eb6","699":"aaaab5ae","734":"11fe947f","867":"344d43e5","974":"249b3806"}[chunkId] + ".js";
};